const DESTINATION_CONTEXT_PREFIXES = ['ura-', 'msg-', 'csat-'];

export const isDestinationContext = (contextName) =>
  typeof contextName === 'string' && DESTINATION_CONTEXT_PREFIXES.some((prefix) => contextName.includes(prefix));

export const isCsatContext = (contextName) => typeof contextName === 'string' && contextName.startsWith('csat-');
